import { welcomeTour } from './welcomeTour';
import { fanTour } from './fanTour';
import { mapTour } from './mapTour';
// import { timelineTour } from './timelineTour';

export const TOUR_CONFIG = {
    welcome: welcomeTour,
    fanDrawn: fanTour,
    mapView: mapTour,
    // timelineView: timelineTour
};